import React, { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import Breadcrumb from '@/components/common/Breadcrumb';
import Card from '@/components/ui/cards/Card';
import CardHeader from '@/components/ui/cards/CardHeader';
import { useParams } from 'react-router-dom';
import { updateItemService, getByIdItemService } from '@/services/ItemServices';
import { useSelector, useDispatch } from 'react-redux';
import validationErrors from '@/lib/validationErrors';
import CustomTabs from '@/components/common/CustomTabs';
import InformationTab from './component/InformationTab';
import ImagesTab from './component/ImagesTab';
import VariationsTabs from './component/VariationsTabs';
import ExtraTabs from './component/ExtraTabs';
import AddonTabs from './component/AddonTabs';

const ItemViewPage = ({ pageTitle }) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const [dataSource, setDataSource] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (id && id != '') {
            getDataById(id);
        }
    }, [id]);

    const getDataById = (id) => {
        setIsLoading(true);
        dispatch(getByIdItemService(id))
            .then((res) => {
                var formData = res?.data?.data;
                setDataSource(formData);
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    return (
        <>
            <Breadcrumb pageTitle={pageTitle} />
            <Card>
                <CardHeader>
                    <h3 className="db-card-title">{pageTitle}</h3>
                </CardHeader>
                <CustomTabs
                    tabsData={[
                        {
                            tabsId: '',
                            title: 'information',
                            icon: 'lab-information',
                            content: <InformationTab dataSource={dataSource} />,
                        },
                        {
                            tabsId: '',
                            title: 'images',
                            icon: 'lab-image',
                            content: <ImagesTab dataSource={dataSource} getDataById={getDataById} />,
                        },
                        {
                            tabsId: '',
                            title: 'variation',
                            icon: 'lab-variation',
                            content: <VariationsTabs dataSource={dataSource} />,
                        },
                        {
                            tabsId: '',
                            title: 'extra',
                            icon: 'lab-extra',
                            content: <ExtraTabs dataSource={dataSource} />,
                        },
                        // {
                        //     tabsId: '',
                        //     title: 'addon',
                        //     icon: 'lab-addon',
                        //     content: <AddonTabs dataSource={dataSource} />,
                        // },
                    ]}
                />
            </Card>
        </>
    );
};

export default ItemViewPage;
